import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  centeredContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default styles;
